export default "__VITE_ASSET__186bc7d3__"